import { render, staticRenderFns } from "./PoiMap.vue?vue&type=template&id=54154e14&"
import script from "./PoiMap.vue?vue&type=script&lang=js&"
export * from "./PoiMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PoiMap.vue"
export default component.exports